import React from 'react';
import AOS from 'aos'
import 'aos/dist/aos.css'
import VanillaTilt from 'vanilla-tilt';
import { Tabs, TabList, TabPanels, Tab, TabPanel, Highlight, Text, SimpleGrid, Box } from '@chakra-ui/react'
import { FrontendSkills, BackendSkills, AllSkills } from '../data';
import { useEffect } from 'react';
import SingleSkills from './SingleSkills';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { memo } from 'react';
const options = {
  scale: 1.1,
  speed: 1000,
  max: 30
};

const Skills = () => {
  const { Theme } = useContext(ThemeContext)
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <section id="skills" className={`${Theme === 'dark' ? "newBackground" : "bg-[#fff]"} pt-12 pb-5`} >
      <Tilt options={options} Theme={Theme} />
      <div className={`container mx-auto`} >
        <Tabs variant='unstyled' align='center' >
          {/* All Tabs Navigation */}
          <TabList mb="10" >
            <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }} >All</Tab>
            <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }}>Frontend</Tab>
            <Tab _selected={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }} borderRadius={"7px"} bg={Theme === "dark" ? "#61605e" : "#fff"} color={Theme === "dark" ? "#fff" : "#000"} ml={["3", "3", "5", "7", "10"]} className='boxShadow' _hover={{ color: 'white', bg: `${Theme === "dark" ? "#F2AA4CFF" : "#F08E8B"}` }}>Backend</Tab>
          </TabList>

          {/* All tabs Show */}

          <TabPanels>
            {/* All Skills */}
            <TabPanel>
              <SimpleGrid columns={[4, 4, 7, 7, 8]} spacing={[2, 2, 2, 4, 6]}>
                {
                  AllSkills.map((el, i) => <SingleSkills skill={el.skill} image={el.image} i={i + 1} />)
                }

              </SimpleGrid>
            </TabPanel>
            {/* Frontend SKills */}
            <TabPanel>
              <SimpleGrid columns={[4, 4, 7, 7, 8]} spacing={[2, 2, 2, 4, 6]} >
                {
                  FrontendSkills.map((el, i) => <SingleSkills skill={el.skill} image={el.image} i={i + 1} />)
                }

              </SimpleGrid>
            </TabPanel>
            {/* Backend Skills */}
            <TabPanel>
              <SimpleGrid columns={[4, 4, 7, 7, 8]} spacing={[2, 2, 2, 4, 6]} >
                {
                  BackendSkills.map((el, i) => <SingleSkills skill={el.skill} image={el.image} i={i + 1} />)
                }

              </SimpleGrid>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </div>
    </section>
  );
};


function Tilt(props) {
  const { options, Theme } = props;
  const tilt = React.useRef(null);

  useEffect(() => {
    VanillaTilt.init(tilt.current, options);
  }, [options]);

  return <Box w={"50%"} ref={tilt} m="auto" data-aos="zoom-out-down" >
    <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb="5" mt="15" fontSize={["25", "25", "30", "40", "40"]} textAlign={"center"} >
      <Highlight query='Skills' styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "red.400"}` }}  >
        My  Skills
      </Highlight>
    </Text></Box>
}
export default memo(Skills);
